import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";

import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Rental from "./pages/Rental";
import Gallery from "./pages/Gallery";
import Advertise from "./pages/Advertise";
import Memberships from "./pages/Memberships";
import Contact from "./pages/Contact";
import Donate from "./pages/Donate";
import Report from "./pages/Finance";
import Constitution from "./pages/Constitution";
import Admin from "./pages/Admin";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there is a hash, let HashLink handle it. If not, scroll to top.
    if (!hash) {
      requestAnimationFrame(() => window.scrollTo(0, 0));
    }
  }, [pathname, hash]);

  return null;
};

export default function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          
          <Route path="admin" element={<Admin />} />

          {/* Redundant pages redirect to Home sections */}
          <Route path="aboutus" element={<Navigate to="/#about" replace />} />
          <Route path="about us" element={<Navigate to="/#about" replace />} />
          <Route path="events" element={<Navigate to="/#events" replace />} />
          <Route path="news" element={<Navigate to="/#news" replace />} />

          <Route path="spaces" element={<Rental />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="advertise" element={<Advertise />} />
          <Route path="memberships" element={<Memberships />} />
          <Route path="contact" element={<Contact />} />
          <Route path="donate" element={<Donate />} />
          <Route path="report" element={<Report />} />
          <Route path="constitution" element={<Constitution />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}